import { Controller } from "stimulus"

// Home search: the city picked as Departure can't be picked as Arrival, and vice versa.
export default class extends Controller {
  static targets = ["origin", "destination"]

  // The search results page loads with the previous search's cities already selected.
  connect() {
    this.sync()
  }

  sync() {
    this.exclude(this.destinationTarget, this.originTarget.value)
    this.exclude(this.originTarget, this.destinationTarget.value)
  }

  exclude(select, cityId) {
    Array.from(select.options).forEach((option) => {
      option.disabled = cityId !== '' && option.value === cityId
    })

    if ($(select).data('selectpicker')) $(select).selectpicker('refresh')
  }
}
